<script setup>
import Spinner from '@/components/shared/core/Spinner.vue'
import ImageDownloadButton from '@/components/shared/buttons/ImageDownloadButton.vue'
import CloseButton from '@/components/shared/buttons/CloseButton.vue'
import TransitionFadeIn from '@/components/shared/transitions/TransitionFadeIn.vue'
import {useImage} from '@/composables/use-image.js'
import {toRefs} from 'vue'
import {onKeyStroke} from '@vueuse/core'

//Emits and props
const emit = defineEmits([
  'close',
  'download',
])
const props = defineProps({
  src: {
    type: [String, File],
    required: true,
  },
  isVisible: {
    type: Boolean,
    default: false,
  },
})

//Image load
const {src} = toRefs(props)
const {image, isLoading} = useImage(src)

//Handle ESC key
onKeyStroke('Escape', () => emit('close'))
</script>

<template>
  <div
    v-if="src && isVisible"
    :class="$style.lightbox"
    @click="$emit('close')"
  >
    <Spinner
      v-if="!image || isLoading"
      color="white"
    />
    <div :class="$style.buttons">
      <ImageDownloadButton
        :class="$style.download"
        @click.stop="$emit('download')"
      />
      <CloseButton
        :class="$style.close"
        @click.stop="$emit('close')"
      />
    </div>
    <TransitionFadeIn>
      <img
        v-if="image"
        :src="image.src"
        :class="$style.image"
        @click.stop
      >
    </TransitionFadeIn>
  </div>
</template>

<style module lang="scss">
.lightbox {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--color-black);
}
.image {
  max-width: 100% !important;
  max-height: 100% !important;
}
.buttons {
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  align-items: center;
  gap: 2rem;
}
</style>
